import { render, staticRenderFns } from "./Prize.vue?vue&type=template&id=4f2048b0"
import script from "./Prize.vue?vue&type=script&lang=ts"
export * from "./Prize.vue?vue&type=script&lang=ts"
import style0 from "./Prize.vue?vue&type=style&index=0&id=4f2048b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports